import { render } from "./clerck.vue?vue&type=template&id=4af2140a&scoped=true"
import script from "./clerck.vue?vue&type=script&lang=js"
export * from "./clerck.vue?vue&type=script&lang=js"

import "./clerck.vue?vue&type=style&index=0&id=4af2140a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af2140a"]])

export default __exports__